import type { EnrichedMatch } from '../types';
import { rigaDateLong, rigaDayKey } from '../format';
import MatchCard from './MatchCard';

interface Props {
  matches: EnrichedMatch[];
  highlightCodes?: string[];
  showOwners?: boolean;
  emptyText?: string;
}

export default function MatchList({ matches, highlightCodes, showOwners, emptyText }: Props) {
  if (matches.length === 0) {
    return <div className="card p-6 text-center text-dim">{emptyText ?? 'No matches.'}</div>;
  }

  const days = new Map<string, EnrichedMatch[]>();
  for (const m of matches) {
    const k = rigaDayKey(m.utc_kickoff);
    if (!days.has(k)) days.set(k, []);
    days.get(k)!.push(m);
  }

  return (
    <div className="space-y-6">
      {[...days.entries()].map(([day, ms]) => (
        <section key={day} className="space-y-2">
          <div className="sticky top-0 z-20 -mx-1 px-1 py-1.5 bg-ink-950/95 backdrop-blur flex items-baseline justify-between">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-dim">
              {rigaDateLong(ms[0].utc_kickoff)}
            </h3>
            <span className="text-xs text-dim">{ms.length} match{ms.length === 1 ? '' : 'es'}</span>
          </div>
          <div className="space-y-2">
            {ms.map((m) => (
              <MatchCard key={m.id} match={m} highlightCodes={highlightCodes} showOwners={showOwners} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
